import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';
import PrintPresupuesto from '../components/cienytech/gestion/presupuestos/print.presupuesto';

const PrintLayout = ({ match: { url } }) => (
  
        <Switch>
          <Route path={`${url}/presupuesto/:id`} component={PrintPresupuesto} />

          {/*Redirect*/}
          <Redirect to={'/errors/404'} />
        </Switch>
      
);

PrintLayout.propTypes = { match: PropTypes.object };

export default PrintLayout;
